import { Team } from "../../component/Team";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";

export const AboutContent = () => {
  const { t } = useTranslation();
  
  return (
    <div style={{ paddingTop: '60px' }}>
      <Container>
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ 
              color: '#333333',
              fontWeight: 'bold',
              marginBottom: '1rem'
            }}>
              {t("COMITÉ ORGANIZADOR")}
            </h1>
            <p className="text-center lead" style={{ color: '#666666' }}>
              {t("Conoce al equipo detrás del CEC 2026")}
            </p>
          </Col>
        </Row>
      </Container>
      <Team />
    </div>
  );
};